/* eslint-disable no-debugger */
import { Fragment } from 'react';

import useNewOrganizationRegistration from './UseNewOrganizationRegistration';

import NewOrganizationRegistrationForm from './NewOrganizationRegistrationForm';

import Headings from '@usas/ui-web/components/headings/Headings';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';
// import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';

const NewOrganizationRegistration = () => {
  const {
    newClubRegistrationStatusState,
    clubRegistrationState,
    formState,
    errorState,
    state,
    organizationTypeState,
    offeringTypeState,
    usasClubStaffState,
    legalEntityTypeState,
    organizationStaffState,
    onValueTextPairChanged,
    onFormValueChanged,
    onSubmitOrganization,
    setFormData,
  } = useNewOrganizationRegistration();

  let content;

  if (newClubRegistrationStatusState.objData.status === "Pending") {
    content = (
      <div className='col-xs-12'>
        <p>You have a new organization registration waiting for approval. Please check back later.</p>
      </div>
    );
  } else if (newClubRegistrationStatusState.objData.status === "Pending Payment") {
    content = (
      <div className='col-xs-12'>
        <p>You have a new organization registration in your cart waiting for payment.</p>
      </div>
    );
  } else {
    content = (
      <div>
        <form noValidate>
          <NewOrganizationRegistrationForm
            state={state}
            formState={formState}
            errorState={errorState}
            organizationTypeState={organizationTypeState}
            legalEntityTypeState={legalEntityTypeState}
            onValueTextPairChanged={onValueTextPairChanged}
            onFormValueChanged={onFormValueChanged}
            setFormData={setFormData}
          />
          <div className='col-xs-12 usas-extra-top-margin'>
            <PrimaryButton onClick={onSubmitOrganization}>Submit</PrimaryButton>
          </div>
        </form>
      </div>
    );
  }

  return (
    <Fragment>
      <div className='row'>
        <div className='col-xs-12'>
          <Headings.H3>New Organization Registration</Headings.H3>
        </div>
        {content}
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={
          newClubRegistrationStatusState.isObjLoading ||
          clubRegistrationState.isObjLoading ||
          usasClubStaffState.isArrayLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={clubRegistrationState.isSaving || usasClubStaffState.isSaving || organizationStaffState.isSaving} />
    </Fragment>
  );
};

export default NewOrganizationRegistration;